import React, { Component } from 'react';
import { Orient } from '@src/slide/application/service/snap-line-service/interface/orient.interface';
import { getOppositeOrient } from '@src/slide/application/service/snap-line-service/util/movement';
import { ArrowLine } from '@src/slide/application/service/snap-line-service/render/components/arrow-line';
import type { IArrowLineProps } from '@src/slide/application/service/snap-line-service/render/components/arrow-line';
import type { IActiveSnapGridLine } from '@src/slide/application/service/snap-line-service/interface/line.interface';
import { IRect } from '@src/slide/infrastructure/module/independent/graphic/rect/rect';
import { IBaseUIProps } from '@src/slide/application/service/snap-line-service/interface/render.interface';

export interface RectSnapLineProps extends IBaseUIProps {
    snapLines: IActiveSnapGridLine[];
    color?: string
    arrowSize: Pick<IRect, 'width' | 'height'>;
}

/**
 * 宽高参考线
 * 会在 frame 基线位置，渲染一个双箭头线。其方向由吸附的方向而定
 */
export class RectSnapLines extends Component<RectSnapLineProps> {
    public render() {
        const { snapLines, scale } = this.props;
        return <>
            {snapLines.map((snapLine) => {
                const { orient } = snapLine;
                const frames = snapLine.refElements.map(ref => ref.outerFrameOnSlide);
                return <>
                    { frames.map((frame, index) => {
                        const arrowLineProps: IArrowLineProps = {
                            orient: getOppositeOrient(orient),
                            range: orient === Orient.VERTICAL ? [frame.left, frame.left + frame.width]
                                : [frame.top, frame.top + frame.height],
                            position: orient === Orient.VERTICAL ? frame.top + (frame.height / 2)
                                : frame.left + (frame.width / 2),
                            scale,
                            strokeWidth: this.props.strokeWidth,
                            arrowSize: this.props.arrowSize,
                            strokeDash: this.props.strokeDash,
                        };

                        return <ArrowLine {...arrowLineProps} key={index}/>;
                    })}
                </>;
            })}
        </>;
    }
}
